/**
 * Eyevol Custom JavaScript
 */

// プログレスバー更新の共通関数
function initProgressBar(carousel, containerSelector) {
  const container = carousel.closest(containerSelector);
  const progressWrapper = container?.parentElement?.querySelector('.eyevol-progress-bar__wrapper');
  const progressBar = progressWrapper?.querySelector('.eyevol-progress-bar');

  if (progressBar && carousel.scrollWidth > carousel.clientWidth) {
    const updateProgress = () => {
      const scrollPercentage = (carousel.scrollLeft / (carousel.scrollWidth - carousel.clientWidth)) * 100;
      progressBar.setAttribute('aria-valuenow', Math.round(scrollPercentage));
      progressBar.style.setProperty('--progress', scrollPercentage / 100);
    };

    updateProgress();
    carousel.addEventListener('scroll', updateProgress, { passive: true });
  }
}

// Featured collections / Blog posts magazine / Multi column product のプログレスバー更新機能
function updateProgressBars() {
  // Featured Collections用
  document.querySelectorAll('.eyevol-card__scroll-carousel').forEach(carousel => {
    initProgressBar(carousel, '.eyevol-card__product-list');
  });

  // Magazine Posts用
  document.querySelectorAll('.eyevol-magazine__scroll-carousel').forEach(carousel => {
    initProgressBar(carousel, '.eyevol-magazine__post-list');
  });

  // Multi Column Product用
  document.querySelectorAll('.eyevol-multi-column-product--scrollable').forEach(carousel => {
    initProgressBar(carousel, '.eyevol-multi-column-product__controls-container');
  });
}

// Multi column lens laaa section のスティッキーメニュー機能（レンズ詳細ページ）
function initLensStickyMenu() {
  const stickyMenu = document.querySelector('.eyevol-lens__sticky-menu');
  const menuItems = document.querySelectorAll('.eyevol-lens__sticky-menu a');

  if (!stickyMenu || menuItems.length === 0) return;

  // スクロール位置に応じてアクティブなメニュー項目を更新
  function updateActiveMenuItem() {
    const scrollPosition = window.scrollY + 100; // オフセット調整

    menuItems.forEach(item => {
      const targetId = item.getAttribute('href').substring(1);
      const targetSection = document.getElementById(targetId);

      if (targetSection) {
        const sectionTop = targetSection.offsetTop;
        const sectionBottom = sectionTop + targetSection.offsetHeight;

        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          menuItems.forEach(mi => mi.classList.remove('active'));
          item.classList.add('active');
        }
      }
    });
  }

  // スムーズスクロール機能
  menuItems.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetSection = document.getElementById(targetId);

      if (targetSection) {
        window.scrollTo({
          top: targetSection.offsetTop - 80, // ヘッダー分のオフセット
          behavior: 'smooth'
        });
      }
    });
  });

  // スクロールイベントリスナー
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        updateActiveMenuItem();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // 初期状態の設定
  updateActiveMenuItem();
}


// DOMContentLoaded時の初期化
document.addEventListener('DOMContentLoaded', function() {
  updateProgressBars();
  initLensStickyMenu();
  initArticleTOC();
});

/**
 * 記事ページの目次自動生成機能
 * h2, h3タグを元に階層的な目次を生成し、アンカーリンクを設定する
 */
function initArticleTOC() {
  const tocContainer = document.getElementById('article-toc');
  const tocList = document.getElementById('article-toc-list');
  const articleBody = document.querySelector('.prose, .eyevol-article-magazine__body, .eyevol-article-news__body, .eyevol-article-athlete__comment-body, .eyevol-article-interview__body');

  if (!tocContainer || !tocList || !articleBody) return;

  const headings = articleBody.querySelectorAll('h2, h3');
  if (headings.length === 0) return;

  let currentH2Item = null;
  let currentH3List = null;

  headings.forEach((heading, index) => {
    const id = `heading-${index}`;
    heading.id = id;

    const link = document.createElement('a');
    link.href = `#${id}`;
    link.className = 'article-toc__link';
    link.textContent = heading.textContent;

    // スムーズスクロール
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById(id);
      if (target) {
        const headerOffset = 80;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    });

    if (heading.tagName.toLowerCase() === 'h2') {
      // h2の場合、新しいリストアイテムを作成
      const listItem = document.createElement('li');
      listItem.className = 'article-toc__item article-toc__item--h2';
      listItem.appendChild(link);
      tocList.appendChild(listItem);

      currentH2Item = listItem;
      currentH3List = null;
    } else if (heading.tagName.toLowerCase() === 'h3' && currentH2Item) {
      // h3の場合、現在のh2の下にネストされたリストを作成
      if (!currentH3List) {
        currentH3List = document.createElement('ol');
        currentH3List.className = 'article-toc__list';
        currentH2Item.appendChild(currentH3List);
      }

      const listItem = document.createElement('li');
      listItem.className = 'article-toc__item article-toc__item--h3';
      listItem.appendChild(link);
      currentH3List.appendChild(listItem);
    }
  });

  tocContainer.style.display = 'block';
}


// Back to Top Button Functionality
function initBackToTop() {
  const backToTopButtons = document.querySelectorAll('.back-to-top');

  backToTopButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
  });
});
}

document.addEventListener('DOMContentLoaded', function() {
  initBackToTop();
});

/**
 * 商品タイトルのバリエーション名更新機能
 * バリエーション切り替え時に、グッズ・アクセサリーの商品タイトルにバリエーション名を表示
 */
function handleVariantTitleUpdate(event) {
  const variant = event.detail?.variant;
  if (!variant) return;

  // イベントが発火したフォームを取得
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  // 商品タイプを確認（グッズまたはアクセサリーの場合のみ更新）
  const productInfo = form.closest('.product-info, .eyevol-product-info');
  if (!productInfo) return;

  const productType = productInfo.getAttribute('data-product-type');
  if (productType !== 'グッズ' && productType !== 'アクセサリー') return;

  // バリエーション名を表示する要素を探す
  const variantTitleElement = productInfo.querySelector('.eyevol-product-info__variant-title[data-variant-title]');
  if (!variantTitleElement) return;

  // 親要素のeyevol-product-info__size-displayを取得
  const sizeDisplay = variantTitleElement.closest('.eyevol-product-info__size-display');

  // バリエーション名を取得
  const variantTitle = variant.title;

  // バリエーション名が存在し、かつ "Default Title" でない場合のみ表示
  if (variantTitle && variantTitle !== 'Default Title') {
    variantTitleElement.textContent = variantTitle;
    // 親要素を表示
    if (sizeDisplay) {
      sizeDisplay.style.display = '';
    }
  } else {
    variantTitleElement.textContent = '';
    // 親要素を非表示にする
    if (sizeDisplay) {
      sizeDisplay.style.display = 'none';
    }
  }
};

// イベント委譲を使用して、documentレベルでvariant:changeイベントをリッスン
// これにより、DOMが動的に変更されてもイベントリスナーが失われることはない
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('variant:change', handleVariantTitleUpdate);
  });
} else {
  document.addEventListener('variant:change', handleVariantTitleUpdate);
}
